import { useFetch } from '@chipinside/fetcher'
import { Translate } from '@chipinside/translate'
import { Divider } from '@mui/material'
import { debounce } from 'lodash'
import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'

import { useCompanySlug } from '#/store/ducks/company'
import { endpoint } from '#/store/services/endpoints'
import ws from '#/utils/websocket'

import FormatAlert from '../Manipulate/FormatAlert'

export default function JobsTab(props) {
  const { farm, handleTabSwitch, isOpen, setIsOpen, setAlerts, context } = props

  const history = useHistory()
  const companySlug = useCompanySlug()
  const [controller, setController] = useState(null)
  /* eslint-disable @typescript-eslint/no-unused-vars */
  const { data } = useFetch({
    controller,
    swrOptions: {
      onSuccess: data => {
        if (data?.slug) {
          setAlerts(prevState => {
            /** Merge new job infos in existing, or create new info */
            if (prevState) {
              return {
                ...prevState,
                jobs: {
                  data: prevState?.jobs ? unionBy(prevState.jobs.data, data, 'slug') : [data],
                  updated_at: Date.now(),
                  status: 'done',
                },
              }
            }
            return {
              jobs: {
                data: [data],
                status: 'done',
                updated_at: Date.now(),
              },
            }
          })
        }
        setController(null)

        if (isOpen) {
          handleTabSwitch(null, 2)
        }
      },
    },
  })

  /** Join new Job to existing ones from the slug */
  const unionBy = (destination, obj, key) => {
    return destination.map(dest =>
      dest[key] && obj[key] === dest[key] ? { ...dest, ...obj } : dest,
    )
  }

  useEffect(() => {
    if (window?.Echo) {
      let channel
      switch (context) {
        case 'system':
          channel = `company.cowmed`
          break
        case 'farm':
          channel = farm ? `farm.${farm}` : null
          break
        case 'company':
          channel = companySlug ? `company.${companySlug}` : null
          break
        default:
          channel = null
      }
      if (channel) {
        return ws.subscribe(channel, {
          job: debounce(evt => {
            if (evt?.slug) {
              setController(endpoint.job.self({ job: evt.slug }))
            }
          }, 5000),
        })
      }
    }
  }, [companySlug, context, farm, window?.Echo])

  const getEndpointByContext = () => {
    switch (context) {
      case 'system':
        return endpoint.system.job.list()
      case 'farm':
        return endpoint.notifications.job({ farm })
      case 'company':
        return endpoint.company.job.list({ company: companySlug })
      default:
        return null
    }
  }

  return {
    key: 'jobs',
    endpoint: getEndpointByContext(),
    content: (
      <React.Fragment key={'notification-tab-jobs-content'}>
        <Divider />
        <FormatAlert {...props} />
      </React.Fragment>
    ),
    footer: [
      {
        text: Translate({ messageKey: 'view_all_tasks' }),
        onClick: () => {
          setIsOpen(false)
          history.push(context === 'farm' ? `/farm/${farm}/import` : `/system/import`)
        },
      },
    ],
  }
}
